"use client";

import { Box, Button, Heading, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { IframeDialog } from "@/_components/ui/IframeDialog";

export function LandingCtaFinal() {
  const t = useTranslations("landing.redesign.cta_final");
  const tBook = useTranslations("landing.cta");

  return (
    <Box
      as="section"
      id="cta"
      aria-labelledby="landing-cta-final-heading"
      bg="primary.500"
      py={{ base: 16, md: 36 }}
      px={{ base: 4, md: 0 }}
      textAlign="center"
      position="relative"
      overflow="hidden"
    >
      <Box
        position="absolute"
        w="600px"
        h="600px"
        borderRadius="full"
        bg="whiteAlpha.100"
        top="-200px"
        right="-100px"
        pointerEvents="none"
      />
      <Box
        position="absolute"
        w="400px"
        h="400px"
        borderRadius="full"
        bg="whiteAlpha.100"
        bottom="-150px"
        left="-100px"
        pointerEvents="none"
      />

      <Box position="relative" zIndex={1} maxW="900px" mx="auto">
        <Heading
          as="h2"
          id="landing-cta-final-heading"
          fontFamily="heading"
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="semibold"
          color="white"
          letterSpacing="-1.5px"
          lineHeight={1.05}
          mb={4}
        >
          {t("title_line1")}
          <br />
          {t("title_line2")}
        </Heading>
        <Text textStyle="sm" color="whiteAlpha.800" mb={9}>
          {t("description")}
        </Text>
        <IframeDialog
          title={tBook("book_demo")}
          trigger={
            <Button
              display="inline-flex"
              alignItems="center"
              gap={2}
              py={4}
              px={9}
              bg="white"
              color="primary.500"
              borderRadius="full"
              textStyle="sm"
              fontWeight="bold"
              fontFamily="heading"
              boxShadow="0 4px 20px rgba(0,0,0,0.15)"
              _hover={{
                transform: "translateY(-3px)",
                boxShadow: "0 12px 32px rgba(0,0,0,0.2)",
              }}
            >
              {tBook("book_demo")} →
            </Button>
          }
          iframeHeight={{ base: "500px", md: "700px" }}
          variant="demo"
        />
        <Text fontSize="12px" color="whiteAlpha.600" mt={3.5}>
          {t("note")}
        </Text>
      </Box>
    </Box>
  );
}
